
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import MDButton from 'components/MDButton';
import MDInput from "components/MDInput";
import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from 'react-router-dom';
import { Oval } from 'react-loader-spinner';
// import Select from 'react-select';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
// import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import * as moment from 'moment';
import { Checkbox } from '@mui/material';
import * as service from '../../services/service';

function SponsorshipPayment() {
    const [state, setState] = useState({
        expensehead: '', ittaxpercent: '', gstpercent: '',
    });
    const [data, setData] = useState([]);
    const [invoiceData, setInvoiceData] = useState([]);
    const [paymentDate, setPaymentDate] = useState(new Date());
    const [paymentId, setPaymentId] = useState('');
    const [totalInvoiceAmount, setTotalInvoiceAmount] = useState('');
    const [itTaxAmount, setITTaxAmount] = useState('0');
    const [gstAmount, setGSTAmount] = useState('0');
    const [payableAmount, setPayableAmount] = useState('0');
    const [paidAmount, setPaidAmount] = useState('0');
    const [balance, setBalance] = useState('');
    const [basicAmount, setBasicAmount] = useState('0');
    const [invoiceAmount, setInvoiceAmount] = useState('0');
    const [errors, setError] = useState({});
    const [loading, setLoading] = useState(false);
    const [isSelected, setIsSelected] = useState([]);
    // const selectStyles = { menu: styles => ({ ...styles, zIndex: 999 }) };    
    const navigate = useNavigate();
    const params = useParams();

    const getPaymentDetails = () => {
        fetch(
            service.GET_SPONSORSHIP_PAYMENT_BY_SPONSORSHIP_ID,
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'XApiKey': JSON.parse(sessionStorage.getItem('userData')).apiKey
                },
                body: JSON.stringify({
                    SponsorshipId: params.id,
                })
            })
            .then(res => res.json())
            .then(result => {
                if (result.length === 1 && result[0].expenseHead === "No Data Found") {
                    setError('No Data Found');
                }
                else {
                    setData(result);
                }
                setTotalInvoiceAmount(result[0].invoiceAmount);
                setBalance(result[0].balance);

            })
            .catch(err => {
                if (err) {
                    setError(err);
                };
            });
    };

    const getDetailsById = (id) => {
        setLoading(true);
        const errs = {};
        if (id > 0) {
            fetch(
                service.GET_SPONSORSHIP_PAYMENT_BY_ID,
                {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'XApiKey': JSON.parse(sessionStorage.getItem('userData')).apiKey
                    },
                    body: JSON.stringify({
                        PaymentId: id,
                    })
                })
                .then(res => res.json())
                .then(result => {
                    if (result.message.messageType === 'Success') {
                        setState({
                            ...state, expensehead: result.expenseHead, ittaxpercent: result.itTaxPercent, gstpercent: result.gstPercent,
                        });
                        setPaymentDate(new Date(result.paymentDate));
                        setITTaxAmount(result.itTaxAmount);
                        setGSTAmount(result.gstAmount);
                        setPaidAmount(result.paidAmount);
                        setPayableAmount(result.payableAmount);
                        setPaymentId(id);
                    }
                    else {
                        errs[".invalid"] = result.message.message;
                        setError(errs);
                    }

                });
        }
        setLoading(false);
    };

    const getInvoiceDetails = () => {
        fetch(
            service.GET_SPONSORSHIP_INVOICE_BY_SPONSORSHIP_ID,
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'XApiKey': JSON.parse(sessionStorage.getItem('userData')).apiKey
                },
                body: JSON.stringify({
                    SponsorshipId: params.id,
                })
            })
            .then(res => res.json())
            .then(result => {
                setInvoiceData(result);
                if (result.length === 0) {
                    setError('No Data Found');
                }
            })
            .catch(err => {
                if (err) {
                    setError(err);
                };
            });
    };

    useEffect(() => {
        getPaymentDetails();
        getInvoiceDetails();
    }, []);

    const validate = () => {
        let isValid = true;
        const errs = {};
        if (isSelected.length === 0) {
            isValid = false;
            errs[".invoiceerr"] = "Please select invoice";
        }
        if (!state.expensehead) {
            isValid = false;
            errs[".expensehead"] = "Please enter expense head";
        }
        if (!state.ittaxpercent) {
            isValid = false;
            errs[".ittaxpercent"] = "Please enter IT Tax Percent";
        }
        if (!state.gstpercent) {
            isValid = false;
            errs[".gstpercent"] = "Please enter GST Percent";
        }
        if (!itTaxAmount) {
            isValid = false;
            errs[".ittaxamount"] = "Please enter IT Tax Amount";
        }
        if (!gstAmount) {
            isValid = false;
            errs[".gstamount"] = "Please enter GST Amount";
        }
        if (!payableAmount) {
            isValid = false;
            errs[".payableamount"] = "Please enter Payable Amount";
        }
        if (!paidAmount) {
            isValid = false;
            errs[".paidamount"] = "Please enter Paid Amount";
        }
        if (!paymentDate) {
            isValid = false;
            errs[".paymentDate"] = "Please enter payment date";
        }
        setError(errs);
        return isValid;
    }
    const changeHandler = (event) => {
        // if (eventExecution !== 'Quotation' && isSelected.length !== 0) {
        if (event.target.name === 'ittaxpercent' || event.target.name === 'gstpercent'
            || event.target.name === 'ittaxamount' || event.target.name === 'gstamount'
            || event.target.name === 'payableamount' || event.target.name === 'paidamount') {
            if (Number.isNaN(parseFloat(event.target.value))) {
                // eslint-disable-next-line
                alert("Please enter numbers only");
                event.target.value = ""; // eslint-disable-line no-param-reassign
            }
        }

        if (event.target.name === 'ittaxpercent') {
            const amt = parseFloat((parseFloat(basicAmount) * parseFloat(event.target.value)) / 100);
            setITTaxAmount(amt);

            const payAmt = parseFloat(invoiceAmount) - (amt + parseFloat(gstAmount))
            setPaidAmount(payAmt);
            setPayableAmount(payAmt);
        }

        if (event.target.name === 'gstpercent') {
            const amt = parseFloat((parseFloat(basicAmount) * parseFloat(event.target.value)) / 100);
            setGSTAmount(amt);

            const payAmt = parseFloat(invoiceAmount) - (amt + parseFloat(itTaxAmount))
            setPaidAmount(payAmt);
            setPayableAmount(payAmt);
        }

        setState({ ...state, [event.target.name]: event.target.value });
        // }
        // else {
        //     // eslint-disable-next-line
        //     alert("Please select invoice");
        // }
    };

    const handleCheckboxChange = (checked, id, basAmt, invAmt) => {
        if (isSelected.includes(id)) {
            setIsSelected((prevState) =>
                prevState.filter((prevItem) => prevItem !== id));

            const bAmt = parseFloat(basicAmount) - parseFloat(basAmt);
            setBasicAmount(bAmt);

            const iAmt = parseFloat(invoiceAmount) - parseFloat(invAmt);
            setInvoiceAmount(iAmt);
        }

        if (checked) {
            isSelected.push(id);
            setIsSelected([...isSelected]);
            const bAmt = parseFloat(basicAmount) + parseFloat(basAmt);
            setBasicAmount(bAmt);

            const iAmt = parseFloat(invoiceAmount) + parseFloat(invAmt);
            setInvoiceAmount(iAmt);
        }
    }

    const UdpateInvoiceStatus = () => {
        isSelected.forEach((element) => {
            fetch(
                service.UPDATE_SPONSORSHIP_INVOICE_STATUS,
                {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'XApiKey': JSON.parse(sessionStorage.getItem('userData')).apiKey
                    },
                    body: JSON.stringify({
                        InvoiceId: element,
                        Status: 'Paid',
                        UpdatedBy: JSON.parse(sessionStorage.getItem('userData')).userId
                    })
                })
                .then(resp => resp.json())
                .then(respo => {
                    if (respo.messageType === 'Failed') {
                        // eslint-disable-next-line
                        alert(respo.message);
                        // navigate('/masters/subassemblymaterialmap');
                    }
                    else {
                        setError(respo.message.message);
                    }
                });

        });
    }

    const submitHandler = e => {
        e.preventDefault();
        const errs = {};
        setLoading(true);
        if (validate()) {
            fetch(
                service.ADD_UPDATE_SPONSORSHIP_PAYMENT,
                {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'XApiKey': JSON.parse(sessionStorage.getItem('userData')).apiKey
                    },
                    body: JSON.stringify({
                        PaymentId: paymentId > 0 ? paymentId : 0,
                        SponsorshipId: params.id,
                        PaymentDate: moment(paymentDate).format("MM/DD/YYYY"),
                        ExpenseHead: state.expensehead,
                        ITTaxPercent: state.ittaxpercent,
                        GSTPercent: state.gstpercent,
                        ITTaxAmount: itTaxAmount,
                        GSTAmount: gstAmount,
                        PayableAmount: payableAmount,
                        PaidAmount: paidAmount,
                        AddedBy: JSON.parse(window.sessionStorage.getItem('userData')).userId,
                        UpdatedBy: JSON.parse(window.sessionStorage.getItem('userData')).userId,
                    })
                })
                .then(res => res.json())
                .then(result => {
                    if (result.messageType === 'Success') {
                        UdpateInvoiceStatus();
                        // eslint-disable-next-line
                        alert(result.message);
                        window.location.reload();
                    }
                    else if (result.messageType === 'Failed') {
                        // eslint-disable-next-line
                        alert(result.message);
                    }
                    else {
                        errs[".invalid"] = result.message.message;
                        setError(errs);
                    }
                });
        }
        setLoading(false);
    }

    const backHandler = () => {
        navigate('/sponsorships');
    }

    const handleEdit = (id) => {
        getDetailsById(id);
    }

    const handleDownload = (fileName, filePath) => {
        setLoading(true);
        const formData = new FormData();
        formData.append("FileName", fileName);
        formData.append("FilePath", filePath);
        fetch(
            service.DOWNLOAD_FILE,
            {
                method: 'POST',
                headers: {
                    'XApiKey': JSON.parse(sessionStorage.getItem('userData')).apiKey
                },
                body: formData
            })
            .then((response) => response.blob())
            .then((blob) => {
                // Create blob link to download
                const url = window.URL.createObjectURL(
                    new Blob([blob]),
                );
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute(
                    'download',
                    fileName,
                );
                // Append to html link element page
                document.body.appendChild(link);
                // Start download
                link.click();
                // Clean up and remove the link
                link.parentNode.removeChild(link);
            });

        setLoading(false);
    };

    return (
        <DashboardLayout>
            <DashboardNavbar />
            <MDBox pt={6} pb={3}>
                <Grid container spacing={6}>
                    <Grid item xs={12}>
                        <Card>
                            <MDBox
                                mx={2}
                                mt={-3}
                                py={3}
                                px={2}
                                variant="gradient"
                                bgColor="info"
                                borderRadius="lg"
                                coloredShadow="info"
                            >
                                <MDTypography variant="h6" color="white">
                                    Payment Details
                                </MDTypography>
                            </MDBox>
                            <Card style={{ alignItems: 'center' }}>
                                {/* <TableContainer component={Paper} style={{ width: '90%', alignSelf: 'center', }}> */}
                                <Table>
                                    <TableRow>
                                        <TableCell style={{ fontWeight: 'bold' }}>
                                            Invoice Amount : {totalInvoiceAmount}
                                        </TableCell>
                                        <TableCell style={{ fontWeight: 'bold' }}>
                                            Balance Amount : {balance}
                                        </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell colSpan="2" align="center">
                                            <TableContainer component={Paper} style={{ width: '95%', alignSelf: 'center', }}>
                                                <Table aria-label="simple table">
                                                    <TableRow style={{ backgroundColor: 'lightgrey' }}>
                                                        <TableCell style={{ fontWeight: 'bold' }}>Select</TableCell>
                                                        <TableCell style={{ fontWeight: 'bold' }}>Invoice No.</TableCell>
                                                        <TableCell style={{ fontWeight: 'bold' }}>Basic Amount</TableCell>
                                                        <TableCell style={{ fontWeight: 'bold' }}>Tax Amount</TableCell>
                                                        <TableCell style={{ fontWeight: 'bold' }}>Total Invoice Amount</TableCell>
                                                        <TableCell style={{ fontWeight: 'bold' }}>Invoice Date</TableCell>
                                                        <TableCell style={{ fontWeight: 'bold' }}>Completion File</TableCell>
                                                        <TableCell style={{ fontWeight: 'bold' }}>Invoice File</TableCell>
                                                        <TableCell style={{ fontWeight: 'bold' }}>Status</TableCell>
                                                    </TableRow>
                                                    <TableBody>
                                                        {invoiceData.map((row) => (
                                                            <TableRow
                                                                key={row.invoiceId}
                                                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                                            >
                                                                <TableCell>
                                                                    <Checkbox checked={isSelected.includes(row.invoiceId)}
                                                                        onChange={(e) => handleCheckboxChange(e.target.checked, row.invoiceId, row.basicAmount, row.totalInvoiceAmount)} id="chkSelect"
                                                                        disabled={row.status === 'Paid'}
                                                                    />
                                                                </TableCell>
                                                                <TableCell width="10%" component="th" scope="row">{row.invoiceNumber}</TableCell>
                                                                <TableCell width="15%" component="th" scope="row">{row.basicAmount}</TableCell>
                                                                <TableCell width="15%" component="th" scope="row">{row.taxAmount}</TableCell>
                                                                <TableCell width="15%" component="th" scope="row">{row.totalInvoiceAmount}</TableCell>
                                                                <TableCell width="15%" component="th" scope="row">{moment(row.invoiceDate).format('DD/MM/YYYY')}</TableCell>
                                                                <TableCell width="20%" component="th" scope="row"><MDButton onClick={() => handleDownload(row.completionFileName, row.completionFilePath)}>{row.completionFileName}</MDButton></TableCell>
                                                                <TableCell width="20%" component="th" scope="row"><MDButton onClick={() => handleDownload(row.invoiceFileName, row.invoiceFilePath)}>{row.invoiceFileName}</MDButton></TableCell>
                                                                <TableCell width="15%" component="th" scope="row">{row.status}</TableCell>
                                                            </TableRow>
                                                        ))}
                                                    </TableBody>
                                                </Table>
                                                <div style={{ fontSize: '12px', color: 'red' }}>{errors[".invoiceerr"] ? errors[".invoiceerr"] : 'Please select invoice'}</div>
                                            </TableContainer>
                                        </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>
                                            <MDInput label="Expense Head" fullWidth value={state.expensehead || ''}
                                                name="expensehead"
                                                onChange={changeHandler}
                                                id="expensehead"
                                            />
                                            <div style={{ fontSize: '12px', color: 'red' }}>{errors[".expensehead"]}</div>
                                        </TableCell>
                                        <TableCell>
                                            <div> Payment Date </div>
                                            <DatePicker
                                                id="paymentDate"
                                                selected={paymentDate}
                                                onChange={date => setPaymentDate(date)}
                                                dateFormat="MM/dd/yyyy"
                                                tabIndex={0}
                                            />
                                            <div style={{ fontSize: '12px', color: 'red' }}>{errors[".paymentDate"]}</div>
                                        </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>
                                            <MDInput label="IT Tax Percent" fullWidth value={state.ittaxpercent || ''}
                                                name="ittaxpercent"
                                                onChange={changeHandler}
                                                id="ittaxpercent"
                                            />
                                            <div style={{ fontSize: '12px', color: 'red' }}>{errors[".ittaxpercent"]}</div>
                                        </TableCell>
                                        <TableCell>
                                            <MDInput label="GST Percent" fullWidth value={state.gstpercent || ''}
                                                name="gstpercent"
                                                onChange={changeHandler}
                                                id="gstpercent"
                                            />
                                            <div style={{ fontSize: '12px', color: 'red' }}>{errors[".gstpercent"]}</div>
                                        </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>
                                            <MDInput label="IT Tax Amount" fullWidth value={itTaxAmount}
                                                name="ittaxamount"
                                                onChange={changeHandler}
                                                id="ittaxamount"
                                            />
                                            <div style={{ fontSize: '12px', color: 'red' }}>{errors[".ittaxamount"]}</div>
                                        </TableCell>
                                        <TableCell>
                                            <MDInput label="GST Amount" fullWidth value={gstAmount}
                                                name="gstamount"
                                                onChange={changeHandler}
                                                id="gstamount"
                                            />
                                            <div style={{ fontSize: '12px', color: 'red' }}>{errors[".gstamount"]}</div>
                                        </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>
                                            <MDInput label="Payable Amount" fullWidth value={payableAmount}
                                                name="payableamount"
                                                onChange={changeHandler}
                                                id="payableamount"
                                            />
                                            <div style={{ fontSize: '12px', color: 'red' }}>{errors[".payableamount"]}</div>
                                        </TableCell>
                                        <TableCell>
                                            <MDInput label="Paid Amount" fullWidth value={paidAmount}
                                                name="paidamount"
                                                onChange={changeHandler}
                                                id="paidamount"
                                            />
                                            <div style={{ fontSize: '12px', color: 'red' }}>{errors[".paidamount"]}</div>
                                        </TableCell>
                                    </TableRow>
                                </Table>
                                {/* </TableContainer> */}
                                <MDBox mt={4} mb={1} textAlign="center">
                                    {loading ? <Oval
                                        heigth="20"
                                        width="20"
                                        color='grey'
                                        ariaLabel='loading'
                                    /> :
                                        <div>
                                            <MDButton color="info" onClick={submitHandler}>
                                                SAVE
                                            </MDButton>  &nbsp;&nbsp;&nbsp;&nbsp;
                                            <MDButton color="info" onClick={backHandler}>
                                                BACK
                                            </MDButton>
                                        </div>
                                    }
                                    {errors ? <div style={{ fontSize: '12px', color: 'red' }}>{errors[".invalid"]}</div> : null}
                                </MDBox>
                            </Card>
                            <br />
                            <Card style={{ alignItems: 'center' }}>
                                {loading ? <Oval
                                    heigth="100"
                                    width="100"
                                    color='grey'
                                    ariaLabel='loading'
                                /> :
                                    <TableContainer component={Paper} style={{ width: '95%', alignSelf: 'center', }}>
                                        <Table aria-label="simple table">
                                            <TableRow style={{ backgroundColor: 'lightgrey' }}>
                                                <TableCell style={{ fontWeight: 'bold' }}>Expense Head</TableCell>
                                                <TableCell style={{ fontWeight: 'bold' }}>Payment Date</TableCell>
                                                <TableCell style={{ fontWeight: 'bold' }}>IT Tax Percent</TableCell>
                                                <TableCell style={{ fontWeight: 'bold' }}>GST Percent</TableCell>
                                                <TableCell style={{ fontWeight: 'bold' }}>IT Tax Amount</TableCell>
                                                <TableCell style={{ fontWeight: 'bold' }}>GST Amount</TableCell>
                                                <TableCell style={{ fontWeight: 'bold' }}>Payable Amount</TableCell>
                                                <TableCell style={{ fontWeight: 'bold' }}>Paid Amount</TableCell>
                                                <TableCell align="center" style={{ fontWeight: 'bold' }}>Action</TableCell>
                                            </TableRow>
                                            <TableBody>
                                                {data.map((row) => (
                                                    <TableRow
                                                        key={row.paymentId}
                                                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                                    >
                                                        <TableCell width="20%" component="th" scope="row">{row.expenseHead}</TableCell>
                                                        <TableCell width="15%" component="th" scope="row">{moment(row.paymentDate).format('DD/MM/YYYY')}</TableCell>
                                                        <TableCell width="15%" component="th" scope="row">{row.itTaxPercent}</TableCell>
                                                        <TableCell width="15%" component="th" scope="row">{row.gstPercent}</TableCell>
                                                        <TableCell width="15%" component="th" scope="row">{row.itTaxAmount}</TableCell>
                                                        <TableCell width="15%" component="th" scope="row">{row.gstAmount}</TableCell>
                                                        <TableCell width="15%" component="th" scope="row">{row.payableAmount}</TableCell>
                                                        <TableCell width="15%" component="th" scope="row">{row.paidAmount}</TableCell>
                                                        <TableCell><MDButton onClick={() => handleEdit(row.paymentId)}>Edit</MDButton></TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                }
                            </Card>
                        </Card>
                    </Grid>
                </Grid>
            </MDBox>
            <Footer />
        </DashboardLayout>
    );
}

export default SponsorshipPayment;